<template>
  <div id="app">
    <TopNav/>
<!--    <transition-->
<!--      name="page"-->
<!--      mode="out-in"-->
<!--    >-->
    <router-view/>
<!--    </transition>-->
    <SystemDialog/>
  </div>
</template>

<script>
import TopNav from "./components/TopNav";
import SystemDialog from "./components/SystemDialog";

export default {
  name: 'App',
  components: {TopNav, SystemDialog}
}
</script>

<style>
.vm--modal.vue-dialog {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 16px);
  max-height: 100dvh;
}

.vm--modal.vue-dialog .vue-dialog-content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

#app {
  //font-family: Lato, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  position: relative;
  height: 100%;
  width: 100%;

}
.eemo-page-shell {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-top: 0;
  box-sizing: border-box;
}
.page-enter-active,
.page-leave-active {
  /*transition: transform 0.3s ease-in-out;*/
  transition: opacity 0.3s, transform 0.3s;
}

.page-enter {
  opacity: 0;
  transform: translateX(30%);
}
.page-leave-to {
  /*transform: translateX(100%);*/
  opacity: 1;
  transform: translateX(0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue